export default "/profile/images/instruction-3-ru.webp?ac19add9560b42d85711902ae19fe387";